import { config } from '@skytech/config'
import { Image } from '@skytech/ui/Image'
import ImageOffIcon from 'mdi-react/ImageOffIcon'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { getListings } from '@/ducks/resaleReducer'
import { APP_ROUTES } from '@/util/appRoutes'
import { numberFormat } from '@/util/formatters/numbers'

import './listings.scss'

const Listings = () => {
  const listings = useSelector(getListings)

  return (
    <div className="listings">
      {listings.length === 0 && (
        <div className="no-results">Ikke noe utstyr tilgjengelig for øyeblikket.</div>
      )}

      <div className="listings__items">
        {/* @ts-ignore */}
        {listings.map(item => (
          <Item key={item.id} {...item} />
        ))}
      </div>
    </div>
  )
}

const Item = ({ id, price, stock, images = '' }: any) => {
  const imageList = images?.split(',') || []

  return (
    <Link className="listings__item" to={APP_ROUTES.resaleListing.replace(':listingId', id)}>
      <div className="listings__item__image">
        {imageList.length > 0 ? (
          <Image
            src={
              imageList.length > 0 ? `${config.API_URL}files/uploads/resale/${imageList[0]}` : ''
            }
            alt="product"
          />
        ) : (
          <ImageOffIcon />
        )}
      </div>

      <div className="listings__item__price">
        <FormattedNumberWithCurrency amount={price} />
      </div>
      <div className="listings__item__stock">På lager: {numberFormat(stock)}</div>
    </Link>
  )
}

export default Listings
